export const LandingPageUtil = {
    openDocumentation: () => {
        window.open('https://tlgeo.xyz/vi/geocloud/doc', '_blank');
    }
};